export class ReportServerSettings {
    url: string;
    username: string;
    password: string;

    constructor(url: string, username: string, password: string) {
        this.url = url;
        this.username = username;
        this.password = password;
    }
}
